__turbopack_context__.v({
  "root": "button-simple-module-scss-module__8mAsKG__root",
});
